import { render, staticRenderFns } from "./mainYikudiaobodan.vue?vue&type=template&id=716a0d17&scoped=true&"
import script from "./mainYikudiaobodan.vue?vue&type=script&lang=js&"
export * from "./mainYikudiaobodan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716a0d17",
  null
  
)

export default component.exports